import {API} from "@/Composables/api";

const getQuestionComments = async (question: string, params = {}) => {
    return API.get(route("questions.comments.index", {question}), params);
};

const getComment = async (group: string, comment: string, params = {}) => {
    return API.get(route("groups.comments.show", {group, comment}), params);
};

const loadMoreComments = async (group: string, modelType: "question" | "comment", modelId: string, params = {}) => {
    return API.get(route("groups.comments.load-more", {group, modelType, modelId}), params);
};

const storeComment = async (
    group: string,
    modelType: "question" | "comment",
    modelId: string,
    formData: any,
    params = {},
) => {
    return API.post(route("groups.comments.store", {group, modelType, modelId}), params, formData);
};

const updateComment = async (group: string, comment: any, params = {}) => {
    return API.put(route("groups.comments.update", {group, comment}), params, comment);
};

const deleteComment = async (group: string, comment: any, params = {}) => {
    return API.delete(route("groups.comments.destroy", {group, comment}), params, comment);
};

export {getQuestionComments, getComment, loadMoreComments, storeComment, updateComment, deleteComment};
